import { render, staticRenderFns } from "./assignment-wise-performance-report.vue?vue&type=template&id=24dc649d&scoped=true&"
import script from "./assignment-wise-performance-report.vue?vue&type=script&lang=js&"
export * from "./assignment-wise-performance-report.vue?vue&type=script&lang=js&"
import style0 from "./assignment-wise-performance-report.vue?vue&type=style&index=0&id=24dc649d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc649d",
  null
  
)

export default component.exports